import { MedalIcon } from '@acb_devel/design-system';
import { Text } from '@acb_devel/design-system';

import styles from './AchievementListItem.module.scss';

export function AchievementListItem({ text }: { text: string }) {
  return (
    <li className={styles.item}>
      <MedalIcon className={styles.item__icon} />
      <Text as="p" variant="body-1" className={styles.item__text}>
        {text}
      </Text>
    </li>
  );
}
